export enum EStatusResposta {
    Sucesso = 1,
    DadosInvalidos = 2,
    Alerta =3,
    Erro = 4
}
